import Error, { type ErrorOptions } from "./Error.js";

export { Error as WebinyError };
export default Error;
export type { ErrorOptions };
